<template>
    <button class="btn btn-attention" type="button" :disabled="isSpinning || disabled" @click="onSubmit">
        <i :class="(isSpinning ? 'visible fa-spin' : 'invisible') + ' fas faw fa-spinner'"
              role="status"
              aria-hidden="true"></i>
        {{title}}
        <i class="invisible fas faw fa-spinner"
           role="status"
           aria-hidden="true"></i>
    </button>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-facing-decorator';

import $ from 'jquery';

@Component
export default class BtnSubmit extends Vue {
  @Prop public title: string;
  @Prop public spinner: boolean;
  @Prop public disabled: boolean;
  @Prop public submitHandler: () => JQueryPromise<any>;

  private isSpinning: boolean = false;

  constructor() {
    super();
  }

  public onSubmit(e) {
    if ($(e.target).is(':disabled')) {
      return;
    }
    this.submit();
  }

  public submit() {
    if (this.isSpinning || this.disabled) return;
    if (this.spinner) {
      this.isSpinning = true;
    }
    this.submitHandler().always(() => this.isSpinning = false);
  }
}
</script>
